export const ADD_WISHLIST_ITEMS_TO_CART = 'ADD_WISHLIST_ITEMS_TO_CART';
export const ADD_WISHLIST_ITEMS_TO_CART_FULFILLED = 'ADD_WISHLIST_ITEMS_TO_CART_FULFILLED';
export const ADD_WISHLIST_ITEMS_TO_CART_REJECTED = 'ADD_WISHLIST_ITEMS_TO_CART_REJECTED';
export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST';
export const ADD_TO_WISHLIST_FULFILLED = 'ADD_TO_WISHLIST_FULFILLED';
export const ADD_TO_WISHLIST_REJECTED = 'ADD_TO_WISHLIST_REJECTED';
export const CLEAR_CLONE_WISHLIST = 'CLEAR_CLONE_WISHLIST';
export const CLONE_WISHLIST = 'CLONE_WISHLIST';
export const CLONE_WISHLIST_FULFILLED = 'CLONE_WISHLIST_FULFILLED';
export const CLONE_WISHLIST_REJECTED = 'CLONE_WISHLIST_REJECTED';
export const CREATE_WISHLIST = 'CREATE_WISHLIST';
export const CREATE_AND_ADD_TO_WISHLIST = 'CREATE_AND_ADD_TO_WISHLIST';
export const FETCH_WISHLIST = 'FETCH_WISHLIST';
export const FETCH_WISHLIST_FULFILLED = 'FETCH_WISHLIST_FULFILLED';
export const FETCH_WISHLIST_REJECTED = 'FETCH_WISHLIST_REJECTED';
export const UPDATE_WISHLIST_NAME = 'UPDATE_WISHLIST_NAME';
export const UPDATE_WISHLIST_REFERENCE = 'UPDATE_WISHLIST_REFERENCE';
export const REMOVE_WISHLIST = 'REMOVE_WISHLIST';
export const UPDATE_WISHLIST_ITEM_QUANTITY = 'UPDATE_WISHLIST_ITEM_QUANTITY';
export const UPDATE_WISHLIST_ITEM_REFERENCE = 'UPDATE_WISHLIST_ITEM_REFERENCE';
export const REMOVE_WISHLIST_ITEM = 'REMOVE_WISHLIST_ITEM';
export const REMOVE_WISHLIST_ITEMS = 'REMOVE_WISHLIST_ITEMS';
export const REMOVE_WISHLIST_ITEMS_FULFILLED = 'REMOVE_WISHLIST_ITEMS_FULFILLED';
export const REMOVE_WISHLIST_ITEMS_REJECTED = 'REMOVE_WISHLIST_ITEMS_REJECTED';
export const CLEAR_ACCOUNT_WISHLIST = 'CLEAR_ACCOUNT_WISHLIST';
export const CLEAR_ADD_WISHLIST_ITEMS_TO_CART = 'CLEAR_ADD_WISHLIST_ITEMS_TO_CART';
